import React from 'react';
import Sidebar from '../component/layout/sidebar';
import { useState } from 'react';
import Header from '../component/layout/header';
import { supabase } from '../supabase';
import { useEffect } from 'react';
import Header2 from '../component/common/title';
import pic16 from '../assets/pic16.png'
import pic17 from '../assets/pic17.png'
import pic18 from '../assets/pic18.png'
import './dashboard.css'
import pic19 from '../assets/pic19.png'
import pic20 from '../assets/pic20.png'
import pic21 from '../assets/pic21.png';
import pic22 from '../assets/pic22.png'
import { Link } from 'react-router-dom';

const Dashboard = () => {


            function getRateData(total) {
            const percentage = (total * 0.1).toFixed(1);

                return {
                    rate: `+${percentage}%`,
                    img: pic20};}



         const [users, setUsers]= useState([]);

        useEffect(() => {
        const getusers = async()=>{
            const res = await supabase.from('users').select('*').order('id', { ascending: true });;
        setUsers(res.data);
        }
        getusers();
        }, []);



         const [events, setEvents]= useState([]);

        useEffect(() => {
        const getevent = async()=>{
            const res = await supabase.from('exbition_event').select('*').order('id', { ascending: true });;
        setEvents(res.data);
        }
        getevent();
        }, []);



         const [exhibitors, setExhibitors]= useState([]);

        useEffect(() => {
        const getexhibitors = async()=>{
            const res = await supabase.from('exhibitors').select('*').order('id', { ascending: true });;
        setExhibitors(res.data);
        }
        getexhibitors();
        }, []);



        const [booking, setBooking]= useState([]);

        useEffect(() => {
        const getbooking = async()=>{
            const res = await supabase.from('bookings').select('*').order('id', { ascending: true });;
        setBooking(res.data);
        }
        getbooking();
        }, []);


        const usersRate = getRateData(users.length);
        const eventsRate = getRateData(events.length);
        const bookingsRate = getRateData(booking.length);
        const exhibitorsRate = getRateData(exhibitors.length);

    const cardsData = [
    {
        id: 1,
        img1: pic16,
        img2: usersRate.img,
        number: 'Total Users',
       title: users.length,
        rate: usersRate.rate

    },
    {
        id: 2,
        img1: pic17,
        img2: eventsRate.img,
        number: 'Total Events',
         title: events.length,
       rate: eventsRate.rate

    },
        {
        id: 3,
        img1: pic18,
        img2: bookingsRate.img,
        number: 'Total Bookings',
         title: booking.length,
       rate: bookingsRate.rate

    },
    {
        id: 4,
        img1: pic19,
        img2: exhibitorsRate.img,
        number: ' Total Exhibitors',
        title: exhibitors.length,
        rate: exhibitorsRate.rate
    }
    ];


    
const [recentBookings, setRecentBookings] = useState([]);



const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
        case "confirmed":
            return "status-confirmed";

        case "pending":
            return "status-pending";

        case "cancelled":
            return "status-cancelled";

        default:
            return "status-default";
    }
};

useEffect(() => {
    const getRecentBookings = async () => {
        const { data, error } = await supabase
            .from('bookings')
            .select(`
                id,
                booking_date,
                status,
                users:user_id (user_name),
                tickets:ticket_id (name)
            `)
            .order('created_at', { ascending: false })
            .limit(3);

        if (!error) {
            setRecentBookings(data);
        }
    };

    getRecentBookings();
}, []);














     const [isSidebarOpen, setIsSidebarOpen] = useState(false);


    return ( 

         <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>


                    <section className='information-container'>
                        <article className='container-content'>
                           <Header2 
                            title="Dashboard Overview"  
                            para="Welcome back! Here's what's happening with your exhibition."
                            />
                        </article>


                        <section className='container-content-sec1'>
                                <article className='cards-container-sec1'>
                                         {cardsData.map((card) => (
                                            <article className='card-sec1' key={card.id}>
                                            <figure className='container-imgs-sec1'>
                                                <img src={card.img1} alt='icon' />

                                                <figure className='container-chart-small-sec1-dashboard'>
                                                    <img src={card.img2} alt='chart' />
                                                    <h2 className='small-textt-sec1-dashboard'>{card.rate}</h2>
                                                </figure>
                                            </figure>
                                            <h2 className='title-cards-sec1'>{card.number}</h2>
                                            <h1 className='number-cards-sec1'>{card.title}</h1>
                                            <h3 className='smalltext-sec1'>{card.subtitle}</h3>
                                            </article>
                                        ))}
                                </article>

                                        

                                        <article className='conatinercards2-sec1'>

                                        <article className='card2-sec1'>
                                            <h2 className='header-card3-sec1'>Bookings Overview</h2>
                                            <img className='chart-sec1' src={pic22} alt='chart'></img>
                                        </article>

                                        <article className='card3-sec1'>
                                            <section className='container-top-part-recent-booking'>
                                                <h2 className='header-card4'>Recent Booking</h2>
                                                <Link to='/booking-management'>
                                                <h2 className='link-to-view-all'>View All</h2>
                                                </Link>
                                            </section>
                                        {recentBookings.map((item) => (
                                            <article className='container-recent-booking'  key={item.id}>
                                               
                                                <article className='container-card4-sec1'>
                                                    <article className='container-name-time_recent-booking'>
                                                    <h2 className='subheader-card4'>   {item.users?.user_name}</h2>
                                                    <article className='containerrr-sub-info-recent-booking-dashboard'>
                                                                <h3 className='name-recent-booking'>{item.tickets?.name}</h3>
                                                                <div className='small-circle-recent-booking-section-dashboard'></div>
                                                                <h3 className='name-recent-booking'>  {new Date(item.booking_date).toLocaleString()}</h3>
                                                            </article>
                                                    </article>
                                                    
                                                       <div className={`containner-status-booking-dashboard ${getStatusClass(item.status)}`}>
                                                            <h3 className='time-recent-booking'>
                                                                {item.status}
                                                            </h3>
                                                        </div>

                                                </article>

                                        </article>
                                        ))}
                                </article>

                                </article>












                        </section>



                   
            </section>
            </section>
        </section>
);
}
 
export default Dashboard;